import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
import PageIntroBanner from '../../components/PageIntroBanner';
import PageSection from '../../components/PageSection';
import PageSectionContent from '../../components/PageSectionContent';
import { colors, typography } from '../../styles';


const styles = css`
  .Amenities_downloadPdfBtn {
    background-color: transparent;
    border: 1.5px solid ${colors.color2};
    transition: all ease .3s;
    padding: 15px 30px;

    h3 {
      font-family: ${typography.SansSerif};
      text-transform: uppercase;
      color: ${colors.color2};
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 1px;
      margin: 0 0 0 0;
    }

    &:hover {
      background-color: ${colors.color3};
      h3 {
        color: #FFFFFF;
      }
    }

  }


`;

function Amenities({ page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1="Amenities"
        background={get(page, 'page_image.contentUrl')}
      />
      <MenuAbout />
      <PageIntroBanner
        headline={get(page, 'page_intro_banner[0].headline')}
        body={get(page, 'page_intro_banner[0].text')}
      />
      {
        get(page, 'download_file_button') &&
        <div className={styles}>
          <div className="container">
            <div className="d-flex justify-content-center mb-3 mb-lg-5 pb-lg-5">
              {
                get(page, 'download_file_button').map(button => (
                  <a
                    className="Amenities_downloadPdfBtn"
                    target="_blank"
                    rel="naopener noreferrer"
                    key={button.button_text}
                    href={button.file.contentUrl}
                  >
                    <h3>{button.button_text}</h3>
                  </a>
                ))
              }
            </div>
          </div>
        </div>
      }
      <PageSection fullwidth>
        {
          page.sections.map(item => (
            <PageSectionContent
              alternating
              key={item.title}
              preTitle={item.pre_title}
              title={item.title}
              body={get(item.body) || ''}
              media={
                <div
                  className="ContentBanner_resultMediaInner"
                  style={{ backgroundImage: `url('${buildThumbnailUrl(get(item, 'image.contentUrl'), { width: 1200, height: 1200 })}')` }}
                />
              }
            />
          ))
        }
      </PageSection>
    </PageWrapper>
  );
}

Amenities.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'aminities',
})(Amenities);



// WEBPACK FOOTER //
// ./src/pages/Amenities/index.js